import { FiscalType } from 'src/api/api.generated'
// import { DepositType } from './deposit-type-input'
import { Select as MuiSelect } from '@mui/material'
import { ListSubheader, MenuItem, Select as VaporSelect } from '@vapor/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { displayFiscalType } from 'src/utils/fiscal-type'

const Select = VaporSelect as unknown as typeof MuiSelect

export const AdvanceFiscalType = {
  INVOICE: FiscalType.INVOICE,
  NON_FISCAL: FiscalType.NON_FISCAL,
  RECEIPT: FiscalType.RECEIPT,
} as const
export type AdvanceFiscalType = typeof AdvanceFiscalType[keyof typeof AdvanceFiscalType]

export type AdvanceFiscalTypeInputProps = {
  value: AdvanceFiscalType | null
  onChange: (value: AdvanceFiscalType | null) => void
  error?: boolean
}

export default function AdvanceFiscalTypeInput({ value, onChange, error }: AdvanceFiscalTypeInputProps) {
  const { t } = useTranslation()

  return (
    <Select<AdvanceFiscalType | ''> //
      fullWidth
      value={value !== null ? value : ''}
      error={error}
      onChange={(event) => {
        switch (event.target.value) {
          case AdvanceFiscalType.INVOICE:
            onChange(AdvanceFiscalType.INVOICE)
            break
          case AdvanceFiscalType.NON_FISCAL:
            onChange(AdvanceFiscalType.NON_FISCAL)
            break
          case AdvanceFiscalType.RECEIPT:
            onChange(AdvanceFiscalType.RECEIPT)
            break
          default:
            onChange(null)
            break
        }
      }}
    >
      <MenuItem value={AdvanceFiscalType.NON_FISCAL}>{displayFiscalType(t, AdvanceFiscalType.NON_FISCAL)}</MenuItem>
      <MenuItem value={AdvanceFiscalType.INVOICE}>{`${displayFiscalType(t, AdvanceFiscalType.INVOICE)} (${t('pms.booking.reservation.deposits.type.fiscal')})`}</MenuItem>
      <MenuItem value={AdvanceFiscalType.RECEIPT}>{`${displayFiscalType(t, AdvanceFiscalType.RECEIPT)} (${t('pms.booking.reservation.deposits.type.fiscal')})`}</MenuItem>
    </Select>
  )
}
